export default __webpack_public_path__ + "static/media/mod03.dc84be39.svg";